exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nselect[data-v-0e0af22e] {\n    color: white;\n    font-weight: bold;\n    border: none !important;\n    outline: none !important;\n}\nselect[data-v-0e0af22e]:focus {\n    color: white;\n}\n\n", ""]);

// exports
